exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input{height:40px;width:350px;font-size:30px}", ""]);

// exports
